export default "__VITE_ASSET__DkyazRx9__"